import React from 'react';
import { useNavigate } from 'react-router-dom';
import { getSubscriptionPaths, localStorageUtil } from '../../../utils/functions';
import W from '../../../components/common/Word';
import {useTranslation} from 'react-i18next';

function SubscriptionOption() {
    const navigate = useNavigate();
    const paths = getSubscriptionPaths();
    const { t } = useTranslation();

    const handleOptionChange = React.useCallback((option) => {
        localStorageUtil.updateObjectItem('subscription', { type: option });
        navigate(paths.steps['size']); // Navigate to size step
    }, [navigate, paths.steps]);

    return (
        <div className="subscription-box py-6">
            <div className="container">
                <div className="row">
                    <div className="col primary-title">
                        <h2><W>subscription.option.title</W></h2>
                    </div>
                </div>
                <div className="row justify-content-center">
                    <div className="col-lg-5">
                        <div className="subscription__item">
                            <div className="body">
                                <span className="icon-meat"></span>
                                <div className="title">
                                    <h3 className="heading"><W>subscription.customize.title</W></h3>
                                    <p><W>subscription.customize.subtitle</W></p>
                                </div>
                            </div>
                            <button className="btn btn--border btn--red" onClick={() => handleOptionChange('customize')} aria-label={t('subscription.customize.label')}><W>subscription.select</W></button>
                        </div>
                    </div>
                    <div className="col-lg-5">
                        <div className="subscription__item">
                            <div className="body">
                                <span className="icon-package"></span>
                                <div className="title">
                                    <h3 className="heading"><W>subscription.curated.title</W></h3>
                                    <p><W>subscription.curated.subtitle</W></p>
                                </div>
                            </div>
                            <button className="btn btn--border btn--red" onClick={() => handleOptionChange('curated')} aria-label={t('subscription.curated.label')}><W>subscription.select</W></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SubscriptionOption;